import { t } from "i18next";

export const redirectToWeb = () => {
  const esimBaseUrl = t("global.header.esimShopLink");
  window.open(esimBaseUrl, "_blank", "noopener,noreferrer");
};
